import { CrashScreen } from "./CrashScreen";

/** Fallback for `AppErrorBoundary`: the crash screen with a support ID. */
export const renderCrashScreen = (error: unknown, scope: "app" | "page") => <CrashScreen error={error} scope={scope} />;